<template>
  <v-flex column wrap class="container">
    <text-field
      v-model="form.apply"
      :validator="vs.apply"
      :label="adminText('workflowsAll.title_768e0c1', 'Title')"
    />
    <textarea-field
      v-model="form.titleDescription"
      :validator="vs.titleDescription"
      :label="adminText('workflowsAll.description_55f8ebc', 'Description')"
    />
    <v-checkbox
      v-model="form.required"
      :label="adminText('workflowsAll.workshops_are_required_0210488', 'Workshops are required')"
    />
    <textarea-field
      v-if="form.required"
      v-model="form.snackbarText"
      :validator="vs.snackbarText"
      :label="adminText('workflowsAll.snackbar_validation_text_622dad3', 'Snackbar validation text')"
    />
  </v-flex>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
export default {
  mixins: [WorkflowDisplay],
  name: 'workshops-form',
  props: {
    initialValues: {
      type: Object,
      default: () => {},
    },
    vs: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      form: {
        apply: 'Apply to workshops',
        titleDescription: 'Here you can register for attending one or more workshops at the event.',
        required: false,
        snackbarText: 'At least one workshop is required',
      },
    }
  },
  watch: {
    form: {
      handler(val) {
        this.$emit('values', val)
      },
      deep: true,
    },
  },
  mounted () {
    if(this.initialValues && Object.keys(this.initialValues).length) {
      this.form = {...this.form, ...this.initialValues}
    }
    this.$emit('values', this.form)
  },
}
</script>

<style scoped>
  .container {
    max-width: 435px;
    margin: 0px;
    padding-left: 0px;
    padding-right: 0px;
  }
</style>
